export default class TermsOfServiceController {

    static get $inject() {
        return ['$stateParams', '$state', '$location', 'CookiesService', 'ApiAccountService'];
    }

    constructor($stateParams, $state, $location, CookiesService, ApiAccountService) {

        this.$stateParams = $stateParams;
        this.$state = $state;
        this.$location = $location;
        this.CookiesService = CookiesService;
        this.ApiAccountService = ApiAccountService;

        this.termOfServiceServerUrl = this.CookiesService.getCookie('termsOfServiceUrl');
        this.termOfServiceServerId = this.$stateParams.termsOfServiceId;

        if (!this.termOfServiceServerUrl) {
            this.$state.go('login');
        }

    }

    userAgreeGoToPanels() {

        this.CookiesService.setCookie('termsOfServiceId', this.termOfServiceServerId);
        this.$state.go('main.panels');
        this.ApiAccountService.getUserDetails();
        this.ApiAccountService.setEndPoint();
    }

    goToTermsOfService() {
        window.open(this.termOfServiceServerUrl);
    }


}












/** WEBPACK FOOTER **
 ** ./src/guest/termsOfService/controller.js
 **/